export const NUMBER = 'number';
export const PASSWORD = 'password';
export const ENTER_PHONE_NUMBER = 'Enter phone number';
